import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@vueuse/head';
import App from './App.vue';
import router from '@/Routers/Index';
import './assets/tailwind.css';
import { useAuthStore } from '@/Views/UserView/Auth/Store/Auth';
import vue3GoogleLogin from 'vue3-google-login';

const app = createApp(App);
const pinia = createPinia();
const head = createHead();

app.use(pinia);
app.use(router);
app.use(head);
app.use(vue3GoogleLogin, {
  clientId: '686768234595-2o9uu3pb8hqq446jht20683u52074hdb.apps.googleusercontent.com'
});

const authStore = useAuthStore();

// Handle authentication initialization
if (localStorage.getItem('token')) {
    await authStore.initializeAuth();
    if (!authStore.isAuthenticated) {
        localStorage.removeItem('token');
    }
}

app.mount('#app');

